module.exports = __webpack_public_path__ + "static/img/zero-knowledge-proof.dfd72c50.png";